<template>
   <div>
    <b-navbar toggleable="md" type="dark" variant="dark">
    
      <b-navbar-brand>
          <!-- <Slidemenu /> -->
          <!-- <img src="../../assets/img/logohpca.png" width="60px"/> -->
      </b-navbar-brand>
      
      <b-navbar-nav >
        <b-nav-item href="/"><router-link class="nav-link" style="padding:0.0rem 0.0rem;font-size:20px;color:white"  to="/">Hampshire Puja and Cultural Association
        <br/><span class="caption"> Promoting Cultural Diversity and Community Cohesion Across Hampshire</span>
        </router-link></b-nav-item>
        <!-- <div style='float: right;color:white;height:25px'>Registered Charity No 1180289</div> -->
      </b-navbar-nav>
      <!-- <b-navbar-nav class="ml-auto">
        Registered Charity No 1180289
      </b-navbar-nav> -->
      <!-- <b-nav-item-dropdown right>
        Registered Charity No 1180289
      </b-nav-item-dropdown> -->
    </b-navbar>     
    <!-- <div class="charityregcontent">
      <div class="charityregnumber nav-link" style="padding: 0rem; font-size: 16px; color: white;">Registered Charity No.1180289</div>
    </div> -->
    <div>
      <div class="fixed-div-na">
          <nav class="navigation">
            <ul class="mainmenu ulmenu">
              
              <!-- <li class="limenu"><router-link to="/About"><font-awesome-icon icon="home" /> ..About</router-link></li>
              <li class="limenu"><router-link to="/Objectives"><font-awesome-icon icon="bullseye" /> ..Objectives</router-link></li>
              <li class="limenu"><router-link to="/Events"><font-awesome-icon icon="calendar-check" /> ..Events</router-link>
              <li class="limenu"><router-link to="/Sponsor"><font-awesome-icon icon="hands-helping" /> ..Sponsor</router-link></li>
              <li class="limenu"><router-link to="/Gallery/PhotoGallery"><font-awesome-icon icon="images" /> ..Gallery</router-link></li>
              <li class="limenu"><router-link to="/Contact"><font-awesome-icon icon="mobile-alt" /> ..Contact</router-link></li> -->
              <li class="limenu"><router-link to="/About">About |</router-link></li>
              <li class="limenu"><router-link to="/Objectives">Objectives |</router-link></li>
              <li class="limenu"><router-link to="/Events">Events  |</router-link>
              <li class="limenu"><router-link to="/Sponsor">Sponsor|</router-link></li>
              <li class="limenu"><router-link to="/Gallery/PhotoGallery">Gallery|</router-link></li>
              <!-- <li class="limenu"><router-link to="/PhotoGallery">Photo Gallery |</router-link></li>
              <li class="limenu"><router-link to="/VideoGallery">Video Gallery |</router-link></li> -->
              <li class="limenu"><router-link to="/Membersroundup">Members' Roundup |</router-link></li>
              <li class="limenu"><router-link to="/Contact">Contact</router-link></li>
            </ul>
          </nav>
        </div>
    </div>
    

   </div>
</template>

<script>
import Slidemenu from '@/components/sections/Slidemenu'


  export default {
    name: 'Headernav',
    components: {
    Slidemenu
    },
    data () {
      return {
        msg: 'Headernav'
    }
  }
}

</script>


<style> 

</style>


// WEBPACK FOOTER //
// src/components/sections/Headernav.vue